import React, { MouseEventHandler, useEffect } from "react";
import { useAlarmListQuery, useReadAlarmMutation } from "src/api/alarmAPI";
import { useNavigate } from "react-router-dom";
import SVG from "src/utils/SVG";
import cn from "classnames";
import styled from "styled-components";
import moment from "moment";
interface IAlarmItemProps {
  data?: any;
  onClick?: MouseEventHandler<HTMLLIElement>;
}

const AlarmListItem = (props: IAlarmItemProps) => {
  const { refetch } = useAlarmListQuery("");
  const [readAlarmUpdate, { isError: completeIsError, isSuccess: completeIsSuccess }] = useReadAlarmMutation();
  const navigate = useNavigate();

  const iconStatus = (t: string) => {
    if (t === "AS") {
      return <SVG name="iconAs" width={32} height={32} viewBox="0 0 32 32" />;
    } else if (t === "ES" || t === "VI" || t === "CO") {
      return <SVG name="iconDoc" width={32} height={32} viewBox="0 0 32 32" />;
    } else if (t === "NO") {
      return <SVG name="iconNotice" width={32} height={32} viewBox="0 0 32 32" />;
    } else {
      // RE
      return <SVG name="iconComment" width={32} height={32} viewBox="0 0 32 32" />;
    }
  };

  const checkedItem = (v: any) => {
    // 안읽었을 경우 읽음 처리
    if (v.read_yn !== "Y") readAlarmUpdate({ push_idx: v.push_idx });

    // 타입에 따른 링크이동
    if (v.type === "AS") {
      navigate("/as-detail/" + v.fk_idx);
    } else if (v.type === "RE") {
      if (v.fk_idx.indexOf("AS") > -1) {
        navigate("/as-detail/" + v.fk_idx);
      } else if (v.fk_idx.indexOf("NX") > -1) {
        navigate("/fulfill-detail/" + v.fk_idx);
      } else {
        navigate("/notice-detail/" + v.fk_idx);
      }
    } else if (v.type === "ES") {
      navigate("/as-detail/" + v.fk_idx);
      // navigate("/estimate-detail/" + v.fk_idx);
    } else if (v.type === "CO") {
      navigate("/as-detail/" + v.fk_idx);
    } else if (v.type === "VI") {
      // navigate("/visitInfo/" + v.fk_idx);
      navigate("/as-detail/" + v.fk_idx);
    } else if (v.type === "AR") {
      // 견적서 반려되고 업체가 변경 되었을때
      alert("반려 사유 : " + v.reason);
    } else if (v.type === "HO") {
      navigate("/home");
    } else if (v.type === "SKU") {
      navigate("/sku-detail/" + v.fk_idx);
    } else if (v.type === "NO") {
      navigate("/notice-detail/" + v.fk_idx);
    } else if (v.type === "EX") {
      navigate("/fulfill-detail/" + v.fk_idx);
    } else {
      return;
      // navigate("/as-detail/" + v.fk_idx);
      // navigate("/report-detail/" + v.fk_idx);
    }

    // 알림 리스트 리렌더링(뒤로가기 눌렀을때 새로고침)
    refetch();
  };

  return (
    <>
      {props.data && props.data.length > 0 ? (
        props.data.map((v: any, idx: number) => {
          return (
            <AlarmSet key={idx} className={cn({ disabled: v.read_yn === "Y" })} onClick={() => checkedItem(v)}>
              <div>{iconStatus(v.type)}</div>
              <div>
                <p className="title">{v.title}</p>
                <p className="content">{v.contents}</p>
                {v.reason && (
                  <>
                    <p className="reject-title">사유</p>
                    <p className="reject">{v.reason}</p>
                  </>
                )}
                <p className="date">{moment(v.insert_date).format("YYYY.MM.DD HH:mm")}</p>
              </div>
            </AlarmSet>
          );
        })
      ) : (
        <NoAlarm>알림 내역이 없습니다.</NoAlarm>
      )}
    </>
  );
};

const AlarmSet = styled.li`
  ${({ theme }) => theme.flexBox.flexMixin("row", "flex-start", "flex-start")}
  > div:first-child {
    padding-right: 23px;
  }
  > div:last-child {
    flex: 1;
    .title {
      font-size: 16px;
      font-weight: 700;
      & + .content {
        margin-top: 10px;
      }
    }
    .content {
      color: ${({ theme }) => theme.color.primary};
      ${({ theme }) => theme.textOverflow.multiLine()};
    }
    .reject-title {
      margin-top: 20px;
      font-weight: 700;
    }
    .reject {
      padding-top: 5px;
      color: ${({ theme }) => theme.color.primary};
      ${({ theme }) => theme.textOverflow.multiLine(1)};
    }
    .date {
      margin-top: 15px;
      color: ${({ theme }) => theme.color.tertiary};
      font-size: 14px;
    }
  }
`;

const NoAlarm = styled.li`
  margin-top: 80px;
  font-size: 16px;
  text-align: center;
`;

export default AlarmListItem;
